import { useState, useEffect } from "react";
import { SPECIFIED_COMMERCIAL_TRANSACTION_LAW_PATH } from "../constants/Constant";

// 取得済データ
let htmlCacheData;

const TokuteishohyokiMain = () => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    if (htmlCacheData) {
      setHtmlContent(htmlCacheData);
      return;
    }

    // 特商法表記を取得
    const fetchData = async () => {
      try {
        const response = await fetch(SPECIFIED_COMMERCIAL_TRANSACTION_LAW_PATH);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.text();
        htmlCacheData = data;
        setHtmlContent(data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchData();
  }, []);

  return (
    <div
      style={{ wordBreak: "normal", fontSize: "small" }}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    ></div>
  );
};

export default TokuteishohyokiMain;
